import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Customized 
} from "recharts";
import InfoIcon from '../../Icons/InfoIcon';


// const data = [
//   { name: "Category 1", PrimaryValue: 4000, SecondaryValue: 2400 },
//   { name: "Category 2", PrimaryValue: 3000, SecondaryValue: 1398 },
//   { name: "Category 3", PrimaryValue: 2000, SecondaryValue: 9800 },
//   { name: "Category 4", PrimaryValue: 2780, SecondaryValue: 3908 }
// ];

// const calculateMaxValue = (data, keys) => {
//   return 23;
//   //return Math.max(...data?.map((item) => Math.max(...keys.map((key) => parseFloat(item[key])))));
// }; 

const calculateMaxValue = (data, keys) => {
  if (!Array.isArray(data)) return 0; // Ensure data is an array
  return Math.max(
    ...data.map((item) => 
      Math.max(
        ...keys.map((key) => {
          const value = parseFloat(item[key]); // Parse values as numbers
          return isNaN(value) ? 0 : value; // Default to 0 if value is NaN
        })
      )
    )
  );
};

const getPath = (x, y, width, height, borderRadius = 5) => {
    const adjustedRadius = Math.min(borderRadius, width / 2, height / 2); // Ensure radius doesn't exceed dimensions

    return `
    M${x},${y} 
    H${x + width - adjustedRadius} 
    A${adjustedRadius},${adjustedRadius} 0 0 1 ${x + width},${y + adjustedRadius} 
    V${y + height - adjustedRadius} 
    A${adjustedRadius},${adjustedRadius} 0 0 1 ${x + width - adjustedRadius},${y + height} 
    H${x} 
    V${y} 
    Z
  `;
};
const CircularBar = (props) => {
    const { fill, x, y, width, height, value } = props;
    let formattedValue = value;
    if(fill==="#B05788") {
      formattedValue = "$"+(value);
    }
    return (
        <>
            <path d={getPath(x, y, width, height)} stroke="none" fill={fill} />
            {/* Add label at the end of the bar */}
            <text
                x={x + width + 5} // Position slightly beyond the bar
                y={y + height / 2} // Centered vertically
                fill="#333"
                fontSize="12"
                dominantBaseline="middle"
            >
                {formattedValue}
            </text>
        </>
    );
};


const generateTicks = (maxValue) => {
  const step = Math.ceil(maxValue / 5); // Step size for 5 intervals
  // console.log([...Array(6)].map((_, i) => i * step));
  return [...Array(6)].map((_, i) => i * step); // Generate ticks at regular intervals
};

const ContractCountSpendChart = ({ data, xAxisLabel, xPrimaryDataKey = "noOfContracts", xSecodaryDataKey = "totalSpend", yDataKey = "name", tooltipMessage= "" }) => {
  
  // console.log(data);
  const roundUpToNearest25 = (value) => Math.ceil(value / 25) * 25;
  const maxPrimaryValue = roundUpToNearest25(calculateMaxValue(data, [xPrimaryDataKey])*1.2); 
  const maxSecondaryValue = roundUpToNearest25(calculateMaxValue(data, [xSecodaryDataKey])*1.2);
  return (
    
    <div style={{ position: "relative" }}>
      <div 
        style={{
          position: "absolute",
          top: "10px", // Adjust as needed
          left: "56%",
          transform: "translateX(-50%)",
          display: "flex",
          alignItems: "center",
          fontSize: "14px",
          color: "#808080",
          zIndex: 300
        }}
      >
        Number of Contracts
        {tooltipMessage && <InfoIcon text={tooltipMessage} />}
    </div>
    <ResponsiveContainer width="100%" height={420}>
      <BarChart
        data={data}
        layout="vertical" // Horizontal bars
        margin={{ top: 25, right: 30, left: 45, bottom: 30 }}
      >
        <CartesianGrid  horizontal={false} vertical={true} />

        {/* Primary X-Axis */}
        <XAxis
          type="number"
          orientation="top"
          axisLine={false} tickLine={false} 
          xAxisId="primary"
          domain={[0, Math.round(maxPrimaryValue)]} // * 1.2
          ticks={generateTicks(maxPrimaryValue)}// ticks={[...Array(6)].map((_, i) => Math.round((Math.round(maxPrimaryValue ) / 5) * i))} // * 1.2
          // label={{ value: "Number of Contracts", position: "top", offset: 10 }}
          // label={({ viewBox }) => {
          //   const { x, y, width } = viewBox;
          //   return (
          //     <span style={{display:"flex"}}><text
          //       x={x + width / 2}
          //       y={y - 10} // Adjust label position
          //       textAnchor="middle"
          //       fontSize={14}
          //       fill="#808080"
          //     >
          //       Number of <tspan fill="red">Contracts1 </tspan>
          //     </text>
          //     <InfoIcon text="Active Contracts include 'Active' and 'In-Progress'" direction='right' /></span>
          //   );
          // }}
        />

        {/* Secondary X-Axis */}
        <XAxis
          type="number"
          orientation="bottom"
          axisLine={false} tickLine={false} 
          xAxisId="secondary"
          domain={[0, Math.round(maxSecondaryValue)]} // * 1.2
          ticks={generateTicks(maxSecondaryValue)} // ticks={[...Array(6)].map((_, i) => Math.round((Math.round(maxSecondaryValue) / 5) * i))} // * 1.2
          label={{ value: xAxisLabel, position: "bottom", offset: 10 }}
        />

        {/* Y-Axis */}
        <YAxis
          dataKey={yDataKey}
          type="category"
          axisLine={false} tickLine={false}
          tick={{ fontSize: 12 }}
        />


        {/* Bars */}
        <Bar
          dataKey={xPrimaryDataKey}
          fill="#0078A7"
          barSize={10}
          name="Primary Axis Bar"
          shape={<CircularBar />}
          xAxisId="primary" // Link to Primary X-Axis
        />
        <Bar
          dataKey={xSecodaryDataKey}
          fill="#B05788"
          barSize={10}
          name="Secondary Axis Bar"
          shape={<CircularBar />}
          xAxisId="secondary" // Link to Secondary X-Axis
        />
      </BarChart>
    </ResponsiveContainer>

    </div>
  );
};

export default ContractCountSpendChart;
